/**
 * Groups scripts related to the new planbox.
 */
import dom from '../../helpers/dom';
import divi from '../../helpers/divi';
import carePlus from './parts/care-plus';
import mobilePlanbox from './parts/mobile-planbox';
import stickyPlanbox from './parts/sticky-planbox';
import directPurchase from './parts/direct-purchase';

const planboxB = () => {
  const planboxClass = 'js-qusd-planbox';
  let planboxElements = [];
  let planboxElementsFound = false;

  const init = () => {
    planboxElements = dom.getByClassName(planboxClass);
    planboxElementsFound = planboxElements.length !== null;
    if (planboxElementsFound) {
      planboxElements.forEach((planboxElement) => {
        directPurchase.registerPurchaseButtons(planboxElement);
      });
    }

    carePlus.init();
    mobilePlanbox.init();
    directPurchase.init();
  };

  const onLoad = () => {
    // Because we need to get the product feature tables' position to know when to
    // display the sticky planboxes, it's better to wait until the page is fully
    // loaded to prevent the table from jumping around.
    if (!divi.inVisualBuilder()) {
      stickyPlanbox.init();
    }
  };

  const onResize = () => {
    if (!divi.inVisualBuilder()) {
      stickyPlanbox.onResize();
    }
  };

  const onScroll = () => {
    if (!divi.inVisualBuilder()) {
      stickyPlanbox.onScroll();
    }
  };

  const onModalOpen = (e) => {
    directPurchase.addModalEventListeners(e);
  };

  const onModalClose = (e) => {
    directPurchase.removeModalEventListeners(e);
  };

  return {
    init,
    onLoad,
    onResize,
    onScroll,
    onModalOpen,
    onModalClose,
  };
};

export default planboxB();
